import {HeadColumns} from "@ui/tableCustom/types/table";
import {ColumnId, IColumnItem} from "@ui/tableCustom/types/columns";


export const getColumnKeys = <T>({
                                     columns,
                                     ignoredExportColumnKey
                                 }: {
    columns: IColumnItem<T>[],
    ignoredExportColumnKey: string,
}):ColumnId<T>[] => {
    if (!columns?.length) {
        return []
    }
    const keys: ColumnId<T>[] = []
    columns.forEach((column) => {
        if (column.hideExport || column.id === ignoredExportColumnKey) {
            return
        }
        keys.push(column.id)
    })
    return keys

}
export const filterHeadColumns = <T>({
                                         headColumns,
                                         keys,
                                         exportFromAllColumns,
                                     }: {
    headColumns: HeadColumns<T>,
    keys: ColumnId<T>[],
    exportFromAllColumns?: boolean
}): HeadColumns<T> => {
    if (exportFromAllColumns) {
        return headColumns
    }
    if (!headColumns?.length) {
        return []
    }

    const isMatrix = headColumns?.length >= 1 && Array.isArray(headColumns[0])
    if (!isMatrix) {
        return headColumns.filter(column => {
            if (Array.isArray(column)) {
                return false
            }
            const id = column.id
            return keys.includes(id) && !column.hideExport
        }) as HeadColumns<T>
    }

    return headColumns.map((columns) => {
        if (!Array.isArray(columns)) {
            return
        }
        return columns.filter((col) => {
            if (col?.exportGroupProps?.rootGroupElement && col?.exportGroupProps?.groupIds?.length) {
                let res = true;
                col.exportGroupProps.groupIds.forEach((id) => {
                    if (!keys.includes(id)) {
                        res = false
                    }
                })
                return res;
            }
            return keys.includes(col.id) && !col.hideExport
        })
    })?.filter((columns) => columns.length >= 1)
}

export const filterColumns = <T>({
                                     columns,
                                     keys,

                                     exportFromAllColumns,
                                 }: {
    columns: IColumnItem<T>[],
    keys: ColumnId<T>[],
    exportFromAllColumns?: boolean
}): IColumnItem<T>[] => {
    if (exportFromAllColumns) {
        return columns
    }
    return columns.filter((col) => keys.includes(col.id))
}